var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#D9D9D9",
    fillOpacity: 0.47
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2701 11.7861C23.3371 9.4451 26.6627 9.4451 27.7297 11.7861L37.1853 32.5311C38.0908 34.5177 36.6388 36.7753 34.4555 36.7753H15.5443C13.3611 36.7753 11.909 34.5177 12.8145 32.5311L22.2701 11.7861Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToHomeIcon);
export default __webpack_public_path__ + "static/media/goToHomeIcon.48cd48251646aed7b01b82fe10f9f41a.svg";
export { ForwardRef as ReactComponent };